// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.languagMenu_language_menu__di33n {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0 20px;
}
.languagMenu_language_menu__di33n button {
  margin: 0 !important;
}
.languagMenu_language_menu__di33n .languagMenu_active__5rp\\+7 {
  background-color: var(--secondary-color);
  border: var(--secondary-color);
  color: white;
}
@media (max-width: 1199px) {
  .languagMenu_language_menu__di33n button {
    font-size: 11px;
    width: 30px;
    height: 30px;
    padding: 0 !important;
  }
}
@media (max-width: 991px) {
  .languagMenu_language_menu__di33n button {
    font-size: 10px;
    width: 25px;
    height: 25px;
    padding-top: 2px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/LanguageMenu/languagMenu.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AACF;AACE;EACE,oBAAA;AACJ;AAEE;EACE,wCAAA;EACA,8BAAA;EACA,YAAA;AAAJ;AAGE;EACE;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,qBAAA;EADJ;AACF;AAIE;EACE;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,2BAAA;EAFJ;AACF","sourcesContent":[".language_menu {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin: 0 20px;\n\n  button {\n    margin: 0 !important;\n  }\n\n  .active {\n    background-color: var(--secondary-color);\n    border: var(--secondary-color);\n    color: white;\n  }\n\n  @media (max-width: 1199px) {\n    button {\n      font-size: 11px;\n      width: 30px;\n      height: 30px;\n      padding: 0 !important;\n    }\n  }\n\n  @media (max-width: 991px) {\n    button {\n      font-size: 10px;\n      width: 25px;\n      height: 25px;\n      padding-top: 2px !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"language_menu": `languagMenu_language_menu__di33n`,
	"active": `languagMenu_active__5rp+7`
};
export default ___CSS_LOADER_EXPORT___;
